import { ProblemDocument } from 'http-problem-details';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ProblemRendererHeaderComponent extends Vue {
  @Prop({ required: true, type: Object })
  public value!: ProblemDocument;

  public get titulo(): string {
    return `${this.value.status} - ${this.value.title}`;
  }
}
